<template>
  <div class="container" style="margin-top: 10vh;">
    <div class="row" v-if="gameStarted">
      <div class="col s2 l1">
        <button class="waves-effect waves-light btn col s12" @click="back()" style="height: 75vh">
          <i class="material-icons">arrow_back_ios</i>
        </button>
      </div>
      <div class="col s8 l10">
        <div class="row">
          <ul class="collapsible popout col s12">
            <li class="collapsible-margin" id="player">
              <div class="collapsible-header">
                <i class="material-icons">inventory</i>Player Supplies
                <i class="material-icons">expand_more</i>
              </div>
              <div class="collapsible-body tech">
                <supply :playerOrBot="player" />
              </div>
            </li>
            <li class="collapsible-margin" id="bot">
              <div class="collapsible-header">
                <i class="material-icons">precision_manufacturing</i>Bot
                Supplies
                <i class="material-icons">expand_more</i>
              </div>
              <div class="collapsible-body tech">
                <supply :playerOrBot="bot" />
              </div>
            </li>
          </ul>
        </div>
        <hr />
        <player-actions v-if="currentStep == 'player-actions'" />
        <player-cleanup v-if="currentStep == 'player-cleanup'" />
        <bot-roll v-if="currentStep == 'bot-roll'" />
        <bot-actions v-if="isANumber(currentStep)" :card="currentBotCard" />
        <bot-cleanup v-if="currentStep == 'bot-cleanup'" />
        <solstice v-if="currentStep == 'solstice'" />
      </div>
      <div class="col s2 l1">
        <button class="waves-effect waves-light btn col s12" @click="next()" style="height: 75vh">
          <i class="material-icons">arrow_forward_ios</i>
        </button>
      </div>
    </div>
    <bot-nation-selection
      v-if="!gameStarted"
      @nation-selected="gameStarted = true"
    />
  </div>
</template>

<script>
import Supply from "./components/Supply.vue";
import BotActions from "./components/BotActions.vue";
import PlayerActions from "./components/PlayerActions.vue";
import BotNationSelection from "./components/BotNationSelection.vue";
import BotRoll from "./components/BotRoll.vue";
import PlayerCleanup from "./components/PlayerCleanup.vue";
import BotCleanup from "./components/BotCleanup.vue";
import Solstice from "./components/Solstice.vue";
import store from "./store.js";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  components: {
    Supply,
    BotActions,
    PlayerActions,
    BotNationSelection,
    BotRoll,
    PlayerCleanup,
    BotCleanup,
    Solstice,
  },
  name: "App",
  setup() {
    const steps = [
      "player-actions",
      "player-cleanup",
      "bot-roll",
      "1",
      "2",
      "3",
      "4",
      "5",
      "bot-cleanup",
      "solstice",
    ];
    const playerTurn = ref(true);
    const gameStarted = ref(false);
    const currentStep = ref(steps[0]);
    const currentBotCard = ref(0);
    const backLocked = ref(false);

    function next() {
      let nextStep = steps[steps.indexOf(currentStep.value) + 1];
      if (nextStep) {
        if (store.bot.roll == nextStep) {
          nextStep = steps[steps.indexOf(currentStep.value) + 2];
        }
        currentStep.value = nextStep;
      } else {
        currentStep.value = steps[0];
        store.bot.canRoll = true;
      }

      if (isANumber(currentStep.value)) {
        currentBotCard.value = currentStep;
      }
    }

    function back() {
      let previousStep = steps[steps.indexOf(currentStep.value) - 1];
      if (previousStep) {
        if (store.bot.roll == previousStep) {
          previousStep = steps[steps.indexOf(currentStep.value) - 2];
        }
        currentStep.value = previousStep;
      } else {
        backLocked.value = true;
        const timeout = setTimeout(() => {
          backLocked.value = false;
          clearTimeout(timeout);
        });
      }

      if (isANumber(currentStep.value)) {
        currentBotCard.value = currentStep;
      }
    }

    function isANumber(potentialNumber) {
      return !window.isNaN(potentialNumber);
    }

    onMounted(() => {
      var elems = document.querySelectorAll(".collapsible");
      window.M.Collapsible.init(elems, {});

      var e = document.querySelectorAll(".sidenav");
      window.M.Sidenav.init(e, {});
    });
    return {
      player: store.player,
      bot: store.bot,
      playerTurn,
      gameStarted,
      currentStep,
      currentBotCard,
      next,
      back,
      isANumber,
    };
  },
});
</script>

<style>
html,
body {
  margin: 0;
  height: 100vh;
  color: white !important;
}
html {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
html {
  background: url(../public/background-2.png) no-repeat center center fixed;
  background-size: cover;
}
.collapsible-header,
.collapsible-body {
  color: white;
  background-color: rgba(36, 46, 50, 0.7);
}

button {
  background-color: #665bb5 !important;
}

nav {
  background-color: #665bb5 !important;
}
</style>
